import menu from './menu.jpg'

export { menu }


// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/Menu/images/index.js